import { getParsedJson } from "./generic.methods";

/**
 * @name @getItem
 * @description get saved items from localstorage
 * @requires key (name) of the saved item
 **/
const getItem = (key) => {
  if (typeof window !== "undefined") return localStorage.getItem(key);
  return null;
};

/**
 * @name @setItem
 * @description save items in localstorage
 * @requires key (name to be saved) value (data to be saved)
 **/
const setItem = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};

/**
 * @name @removeItem
 * @description remove saved items from localstorage
 * @requires key (name) of the saved item
 **/
const deleteItem = (key) => {
  window.localStorage.removeItem(key);
};
const clearAll = (key) => {
  window.localStorage.clear();
};

export const getParsedStorage = (key) => {
  if (typeof window !== "undefined") return getParsedJson(getItem(key));
  return null;
}

export const getItemFromParsedStorage = (key, property) => {
  return getParsedStorage(key)?.[property]
}

export const updateStorageItem = (key, payload) => {
  let savedItem = getItem(key) || {};
  if(Object.keys(getParsedJson(savedItem))?.length) {
    payload = {...getParsedJson(savedItem), ...payload }
  }
  return setItem(key, payload)
}

/** export all */
const storage = {
  getItem,
  setItem,
  deleteItem,
  clearAll,
  getParsedStorage,
  getItemFromParsedStorage,
  updateStorageItem,
};
export default storage;
